import { useEffect, useRef } from 'react';

import { track } from '@/config/observability';

/**
 * One `my_learning_searched` per settled search: after the debounce, once the
 * results for that query have loaded. The query text itself is never sent.
 */
export function useTrackLibrarySearch(
  search: string,
  resultCount: number | undefined,
  hasFilters: boolean
): void {
  const lastTracked = useRef('');
  useEffect(() => {
    if (!search || resultCount === undefined) return;
    if (lastTracked.current === search) return;
    lastTracked.current = search;
    track('my_learning_searched', {
      result_count: resultCount,
      has_filters: hasFilters,
    });
  }, [search, resultCount, hasFilters]);
}
